import { QueryParamProvider } from '../ports/QueryParamProvider';

type AwinParameter = 'awc';

export class ExtractAwinInformation {
  constructor(private readonly queryParamProvider: QueryParamProvider) {}

  extract(param: AwinParameter) {
    return this.queryParamProvider.get(param);
  }
}
